import type { CourseModule } from "@/core/types";
import { lektionDrucken } from "./lektion-01-drucken";
import { lektionKopfFusszeile } from "./lektion-02-kopf-fusszeile";
import { lektionWeitergabe } from "./lektion-03-weitergabe";

export const modulDrucken: CourseModule = {
  id: "drucken",
  title: "Drucken und Weitergabe",
  summary:
    "Eine Datei, die man aus der Hand geben kann – lesbar auf Papier, mit Kopf- und " +
    "Fußzeile, sinnvollen Seitenumbrüchen und ohne Überraschungen im Gepäck.",
  level: "Aufbau",
  lessons: [lektionDrucken, lektionKopfFusszeile, lektionWeitergabe],
};
